module.exports = __webpack_public_path__ + "static/media/lv.35ddb2f3.svg";